<template>
    <div :class="['checkout-tile', {'has-footer': isInFlyin}]">
        <div class="input-type-radio">
            <input type="radio" @click="setSelected(); updateSelectedAddress();"
                :id="inputId"
                :name="inputName"
                :value="option.id"
                :checked="!isInFlyin || selected" />

            <label :for="inputId" class="vue-form-group-label">
                <span class="body-text">
                    <b>{{option.fieldValues.firstName}} {{option.fieldValues.lastName}}</b><br>
                    <span v-html="formatedAddress" />
                </span>
            </label>

            <footer class="checkout-tile-footer" v-if="isInFlyin">
                <ul v-if="!deleteMode">
                    <li v-if="!option.isDefault" @click="setDefault()"><a>{{ resources.setDefaultCTA }}</a></li>
                    <li v-if="option.isDefault" >&nbsp;</li>
                    <li @click="toggleDelete"><a>{{ resources.deleteCTA }}</a></li>
                    <li><a @click="edit(option.id)">{{ resources.editCTA }}</a></li>
                </ul>

                <ul v-if="deleteMode">
                    <li>{{ resources.removeAddressWarning }}</li>
                    <li @click="remove()"><a>{{ resources.confirmDeleteCTA }}</a></li>
                    <li @click="toggleDelete"><a>{{ resources.confirmCancelCTA }}</a></li>
                </ul>
            </footer>
        </div>
    </div>
</template>

<script src="./address-option-tile.js" />
